import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import Posts from "./Components/HospitalMarketing/Posts";
import ChatWithDesigner from "./Components/HospitalMarketing/ChatWithDesigner";
import SelectFrame from "./Components/HospitalMarketing/SelectFrame";
import { getuserdata } from "../../services/apiService";
import MonthlyPostingPlan from "./Components/HospitalMarketing/MonthlyPostingPlan";
import PosterSettings from "./Components/HospitalMarketing/PosterSettings";


const DoctorMarketing = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Posts");
    const [analytics, setAnalytics] = useState({
        facebook: {
            trend: 'up',
            percentage: 15,
            color: '#4CAF50',
            label: 'Facebook'
        },
        instagram: {
            trend: 'down',
            percentage: -8,
            color: '#F44336',
            label: 'Instagram'
        },
        twitter: {
            trend: 'up',
            percentage: 12,
            color: '#4CAF50',
            label: 'Twitter'
        },
        linkedin: {
            trend: 'up',
            percentage: 5,
            color: '#4CAF50',
            label: 'LinkedIn'
        }
    });

    useEffect(() => {
        getUserData();
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab');
        if (tab) {
            setTabseset(tab);
        }
    }, []);

    const handleTabs = (tab) => {
        window.history.pushState({}, '', `?tab=${tab}`);
        setTabseset(tab);
    };

    const getUserData = async () => {
        const userData = await getuserdata('full');
        setUserdata(userData);
    };

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-${tabsest == "Select Frame" || tabsest == "Monthly Posting Plan" ? '12' : '8'}`}>
                            <div className="dc-user-account">
                                <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder" style={{ display: 'flex' }}>
                                    <div className="dc-dashboardtabs">
                                        <ul className="dc-tabstitle nav navbar-nav">
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Posts" ? 'active' : ''} `} href="#" onClick={() => handleTabs("Posts")}>
                                                    Posts
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Chat With Designer" ? 'active' : ''} `} href="#" onClick={() => handleTabs("Chat With Designer")}>
                                                    Chat With Designer
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Select Frame" ? 'active' : ''} `} href="#" onClick={() => handleTabs("Select Frame")}>
                                                    Select Frame
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Monthly Posting Plan" ? 'active' : ''} `} href="#" onClick={() => handleTabs("Monthly Posting Plan")}>
                                                    Monthly Posting Plan
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {tabsest == "Chat With Designer" && (
                                        <ChatWithDesigner userdata={userdata} />
                                    )}
                                    {tabsest == "Select Frame" && (
                                        <SelectFrame />
                                    )}
                                    {tabsest == "Monthly Posting Plan" && (
                                        <div className="col-xs-8 col-sm-12 col-md-12 col-lg-9" style={{ backgroundColor: '#fff' }}>
                                            <MonthlyPostingPlan userdata={userdata} />
                                        </div>
                                    )}
                                    {tabsest == "Poster Settings" && (
                                        <div className="col-xs-8 col-sm-12 col-md-12 col-lg-9" style={{ backgroundColor: '#fff' }}>
                                            <PosterSettings userdata={userdata} />
                                        </div>
                                    )}
                                    {tabsest == "Posts" && (
                                        <div className="col-xs-8 col-sm-12 col-md-12 col-lg-9" style={{ backgroundColor: '#fff' }}>
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                                        <h5 className="mb-0 font-weight-bold">Social Media Analytics</h5>
                                                        <Badge bg="success">Live Data</Badge>
                                                    </div>

                                                    {/* Analytics Cards Grid */}
                                                    <div className="row">
                                                        {Object.entries(analytics).map(([platform, data]) => (
                                                            <div key={platform} className="col-12 col-md-6 mb-3">
                                                                <div className="card" style={{
                                                                    border: '1px solid #e8e8e8',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(-3px)';
                                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                                                                    }}>
                                                                    <div className="card-body">
                                                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                                                            <div>
                                                                                <h6 className="mb-1 font-weight-bold" style={{ fontSize: '18px' }}>
                                                                                    {data.label}
                                                                                </h6>
                                                                                <small className="text-muted">Engagement Rate</small>
                                                                            </div>
                                                                            <div className="text-end">
                                                                                <div style={{
                                                                                    fontSize: '24px',
                                                                                    fontWeight: '700',
                                                                                    color: data.color,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '5px'
                                                                                }}>
                                                                                    <span>{data.percentage > 0 ? '+' : ''}{data.percentage}%</span>
                                                                                    <i className={`fa fa-arrow-${data.trend === 'up' ? 'up' : 'down'}`}
                                                                                        style={{ fontSize: '18px' }}></i>
                                                                                </div>
                                                                                <small className="text-muted">vs last month</small>
                                                                            </div>
                                                                        </div>

                                                                        {/* Progress Bar */}
                                                                        <div style={{
                                                                            height: '8px',
                                                                            backgroundColor: '#f0f0f0',
                                                                            borderRadius: '4px',
                                                                            overflow: 'hidden'
                                                                        }}>
                                                                            <div style={{
                                                                                width: `${Math.min(Math.abs(data.percentage) * 5, 100)}%`,
                                                                                height: '100%',
                                                                                backgroundColor: data.color,
                                                                                borderRadius: '4px',
                                                                                transition: 'width 0.5s ease'
                                                                            }}></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                            {tabsest == "Posts" && (
                                <Posts />
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default DoctorMarketing;
